import { useStore as t } from "@nanostores/react";
import { useState as a, useCallback as c, useEffect as f } from "react";
import { atom as r } from "nanostores";
import { CopilotSession as n } from "../session.js";
import { currentCopilotSession as u } from "../global-state.js";
const p = r(void 0), m = r(null);
function g(e) {
  const [o, i] = a(() => new n()), l = c(() => {
    const s = new n();
    return i(s), s;
  }, []);
  return f(() => {
    e?.isPrimary && u.set(o);
  }, [o, e?.isPrimary]), o.reset == null && Object.assign(o, { reset: l }), o;
}
function M() {
  return t(u);
}
function w(e) {
  return t(e?.__id ?? p);
}
function y(e) {
  return t(e?.__status ?? m);
}
function P(e) {
  return t(e.__statefulMessages);
}
function h(e) {
  return t(e.__tools);
}
function v(e) {
  return t(e.__meta);
}
function I(e) {
  return t(e.__queuedMessages);
}
function W(e) {
  return t(e.__enableWebSearch);
}
export {
  h as useCopilotAvailableTools,
  P as useCopilotMessages,
  v as useCopilotMeta,
  I as useCopilotQueuedMessages,
  g as useCopilotSession,
  w as useCopilotSessionId,
  y as useCopilotStatus,
  W as useCopilotWebSearch,
  M as usePrimaryCopilotSession
};
